import ReactGA from "react-ga";

class GoogleAnalyticsUtil {
    private readonly _trackingId: string = "UA-36515646-9";
    private readonly _env: string = process.env.REACT_APP_GA_ENV || "dev";
    private readonly _category: string = "status page";

    initialize = (): void => {
        ReactGA.initialize(this._trackingId, {
            titleCase: false,
            gaOptions: {
                alwaysSendReferrer: true,
            }
        });
    };

    setDimensions = (merchantName: string, pipefyId: string, merchantStatus: string) => {
        ReactGA.set({dimension1: merchantName});
        ReactGA.set({dimension2: pipefyId});
        ReactGA.set({dimension3: merchantStatus});
        ReactGA.set({dimension4: this._env});
    };


    trackPage = (title: string): void => {
        ReactGA.pageview(title);
    };

    trackEvent = (action: string): void => {
        ReactGA.event({
            action: action,
            category: this._category,
            label: " ",
        });
    };
}

export default GoogleAnalyticsUtil;
